import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {axiosInstance} from '../services/Api';


// Async thunk to fetch all articles
export const fetchArticles = createAsyncThunk(
  'articles/fetchArticles',
  async (filter, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post('/articles/getFiltredArticle',filter);      
      return response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue({ error: 'Failed to fetch articles' });
    }
  }
);



// Async thunk to create an article
export const createArticle = createAsyncThunk(
  'articles/createArticle',
  async (articleData, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post('/articles', articleData);
      return response.data;
    } catch (error) {
      // Check if the error is a response from the server
      if (error.response) {
        // Return the error message from the server
        return rejectWithValue(error.response.data.message);
      }
      // For other errors (e.g., network issues)
      return rejectWithValue('An error occurred while creating the article.');
    }
  }
);
// Async thunk to update an article
export const updateArticle = createAsyncThunk(
  'articles/updateArticle',
  async (articleData, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post('/articles', articleData);
      return response.data;
    } catch (error) {
      // Check if the error is a response from the server
      if (error.response) {
        // Return the error message from the server
        return rejectWithValue(error.response.data.message);
      }
      // For other errors (e.g., network issues)
      return rejectWithValue('An error occurred while creating the article.');
    }
  }
);


// Async thunk to delete an article
export const deleteArticle = createAsyncThunk(
  'articles/deleteArticle',
  async (id, { rejectWithValue }) => {
    try {
      await axiosInstance.delete(`/articles/${id}`);
      return id; // Return the deleted article's ID
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue({ error: 'Failed to delete article' });
    }
  }
);


// Create the article slice
const articleSlice = createSlice({
  name: 'articles',
  initialState: {
    articleData: [],
    pagination: {},  // For storing pagination info
    loading: false,
    error: null,
    message:null,
    selectedArticle:null,
  },
  reducers: {
    clearAlerts(state){
      state.message=null;
      state.error=null;
    },
    setSelectedArticle: (state, action) => {
      state.selectedArticle = action.payload; // Set the selected article
    },
    clearSelectedArticle: (state) => {
      state.selectedArticle = null; // Clear the selected article
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchArticles.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchArticles.fulfilled, (state, action) => {
        state.loading = false;
        state.articleData = action.payload.articles; // Extract articles
        state.pagination = action.payload.pagination; // Extract pagination 
        clearSelectedArticle();
      })
      .addCase(fetchArticles.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;

      })
      .addCase(createArticle.pending, (state) => {
        state.loading = true;
        state.error = null; 

      })
      .addCase(createArticle.fulfilled, (state, action) => {
        state.loading = false;
        state.articleData.push(action.payload);
        state.message="Article cree avec succes"      
      })
      .addCase(createArticle.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload
      })
      .addCase(updateArticle.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateArticle.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.articleData.findIndex(article => article._id === action.payload._id);
        if (index !== -1) {
          state.articleData[index] = action.payload;
          state.message="Article modifier avec succes"
        }
      })
      .addCase(updateArticle.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(deleteArticle.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteArticle.fulfilled, (state, action) => {
        state.loading = false;
        state.articleData = state.articleData.filter(article => article._id !== action.payload);
        state.message='Article supprime'
      })
      .addCase(deleteArticle.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});


// Export the reducer to be used in the store
export const { clearAlerts , setSelectedArticle, clearSelectedArticle} = articleSlice.actions;
export default articleSlice.reducer;
